import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({
  easing: 'ease',
  speed: 1000,
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.3
})
// 打开进度条
export const start = () => {
  NProgress.start()
}
// 关闭进度条
export const close = () => {
  NProgress.done()
}